export default "__VITE_ASSET__p2tbdPpb__"